import { render } from "./NewMedia.vue?vue&type=template&id=3be64fc6&scoped=true"
import script from "./NewMedia.vue?vue&type=script&lang=js"
export * from "./NewMedia.vue?vue&type=script&lang=js"

import "./NewMedia.vue?vue&type=style&index=0&id=3be64fc6&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be64fc6"]])

export default __exports__